/* Engelse teksten voor de NL/EN-schakelaar. Sleutels = data-i18n in de secties. */
window.RPA_EN = {
  banner: "",
  cta: "Secure your spot",
  seeDates: "See the dates",
  heroEyebrow: "Level A training · Roosendaal",
  heroTitle: "From <em>passion</em> to <em>income</em>, in five days",
  heroSub: "Monday you step onto the Reformer as a student.<br>Friday you teach your own class and walk out certified.",
  proof: "<strong style=\"color:#fff\">200+ instructors trained in 2026</strong> · Built with 30+ Reformer studios in the Netherlands",
  heroBadge: "<b>Max 15</b>women per group, so you get real attention",
  altHero: "Student on the Reformer during the training",
  usp1: "5 days, Monday to Friday",
  usp2: "Max 15 per group",
  usp3: "Certified after your exam",
  usp4: "Pay in 3 with Klarna",
  usp5: "Practical exam on day five",
  whoEyebrow: "Who it's for",
  whoTitle: "For the woman who already feels <em>at home</em> on the Reformer",
  who1t: "You already work in wellness",
  who1p: "As a massage therapist, beauty specialist, yoga teacher or personal trainer. Reformer pilates fits right next to what you already offer.",
  who2t: "You want to work with what you love",
  who2p: "You love pilates and want to make it your work. Teaching in a studio, or running your own classes on your own schedule.",
  who3t: "Rather do it together? You can",
  who3p: "Not keen on coming alone? Then bring a friend or colleague. With a duo booking you both get 10% off.",
  flipEyebrow: "No experience needed",
  flipTitle: "You don't need to have <em>ever</em> taught before",
  flipLines: "You've been on the Reformer for a while.<br>You love it.<br>And somewhere you've wondered if you could be the one in front of the group.<br><strong>That feeling is right.</strong><br>You just haven't had the five days yet.",
  flipBody: "We start with the fundamentals and build across five days. By Friday you've taught, been corrected, and taught again.",
  chk1: "No instructor qualification needed to enrol",
  chk2: "Experience with Pilates, sport or movement helps, but isn't required",
  chk3: "You practise on your group, not on paper",
  chk4: "Feedback from your trainer every single day",
  altStart: "Student practising on the Reformer with guidance",
  progEyebrow: "The programme",
  progTitle: "From your first spring setting to your <em>practical exam</em>",
  progLead: "Every day runs on the Reformer itself. You learn a section, then you teach it back.",
  d1l: "Day one", d2l: "Day two", d3l: "Day three", d4l: "Day four", d5l: "Day five",
  d1t: "You work safely on the machine",
  d1p: "Anatomy, posture and the fundamentals of Reformer Pilates, before anyone teaches anything.",
  d2t: "You know the core repertoire",
  d2p: "The beginner exercises, spring settings, and the mistakes everyone makes in their first week.",
  d3t: "You build your own class",
  d3p: "From easy to hard, with progressions for every level, without losing the person at the back.",
  d4t: "You lead a full class",
  d4p: "Cueing, hands on corrections, and taking a group with you from start to finish.",
  d5t: "You teach and earn your certificate",
  d5p: "Technique, class structure, cueing and safety all come together in your exam class.",
  trEyebrow: "Our team",
  trTitle: "Meet <em>our team</em>",
  trLead: "You'll spend five days with us, so it's good to know who we are.",
  vidPlay: "Hear it from your trainer",
  vidEyebrow: "Hear it from your trainer",
  vidTitle: "What the week <em>really</em> feels like",
  vidBody: "What's asked of you, how the days run and why it's so rewarding. In 45 seconds, from one of our trainers.",
  vidNote: "45 seconds, in Dutch with Dutch subtitles.",
  altCert: "A student receiving her certificate",
  certCap: "This moment, on Friday",
  trBio: "[Years on the Reformer] · [certifications] · teaches days [x to y]",
  inEyebrow: "What you get",
  inTitle: "Everything's <em>included</em>",
  inLead: "No extra costs at the door. No surprises after day one.",
  in1: "Five practice days on the Reformer, in a group of no more than 15",
  in2: "Lesson material you keep, to prepare and look back on",
  in3: "Practical exam and certificate on the final day",
  in4: "An Academy goodie bag",
  in5: "A healthy lunch every day, and a closing dinner on Friday",
  inNote: "Staying over? Otium Wellness Hotel next door gives students a fixed rate. <a href=\"#hotel\">Read more</a>",
  altIncl: "Exercise on the Reformer",
  prEyebrow: "Your investment",
  prTitle: "Come alone, or <em>together</em>",
  prDeadline: "",
  prLead: "Together is more fun. And with a duo booking, it costs less too.",
  soloT: "Just you",
  solo1: "Your own spot in a group of no more than 15",
  solo2: "Everything included, from lesson material to lunch",
  solo3: "Pay in 3 with Klarna",
  soloCta: "Pick your week",
  duoTag: "10% off for both of you",
  duoT: "With your friend or colleague",
  duo1: "Two spots in the same week",
  duo2: "Practise together, take your exam together",
  duo3: "Pay together in 3 with Klarna",
  duoCta: "Book as a duo",
  prTeamLink: "Booking three or more spots for your studio or team? <a href=\"#team\">See the team discount</a>",
  wkEyebrow: "Dates",
  wkTitle: "Pick your <em>week</em>",
  wkLead: "Level A starts several times a month. Booked weeks stay on the list so you can see how fast they go.",
  wkFor: "I'm booking",
  wkSolo: "Solo", wkDuo: "Duo",
  hoEyebrow: "Staying over",
  hoTitle: "Coming from further away? <em>Sleep next door.</em>",
  hoBody: "Otium Wellness Hotel is a two minute walk from the studio. Students get a fixed rate there, so you can do the full week without a commute at either end of the day.",
  ho1: "Two minutes' walk to the studio",
  ho2: "Fixed rate for students",
  ho3: "A quiet place to recharge after a full day on the Reformer",
  ceEyebrow: "Your certificate",
  ceTitle: "What your certificate <em>actually</em> means",
  ce1: "We asked more than 30 Reformer studios in the Netherlands what they look for when they hire an instructor. Their answers became our curriculum. Your exam on day five tests you on exactly that.",
  ceQuote: "Your certificate proves you meet the standard those studios hire on.",
  ce2: "We issue it ourselves. There is no national register for Reformer Pilates in the Netherlands, so studios go on skill and on where you trained. That is what the exam is for. After Level A you can teach beginner and intermediate classes on your own, or carry on to Level B and C.",
  rvEyebrow: "Reviews",
  rvTitle: "What our <em>graduates</em> say",
  rv1: "I had never taught anyone anything. On Friday I taught a full class and my hands weren't even shaking.",
  rv2: "Fifteen people sounds like a lot until you're there. My trainer corrected my cueing three times on day two alone.",
  rv3: "One week off work and it was done. I could never have committed to eight days spread over two months.",
  rvJul: "July 2026", rvAug: "August 2026",
  tbEyebrow: "For studios",
  tbTitle: "Training your whole <em>team</em>?",
  tbLead: "The more spots you book, the less you pay per spot. In the same week, or spread across several dates.",
  t1: "1 spot", t1s: "One instructor, one week",
  t2: "2 to 4 spots", t2s: "10% off per spot",
  t3: "5 spots or more", t3s: "15% off per spot",
  cSeats: "Number of spots",
  cPer: "Per spot",
  cSave: "You save",
  cTotal: "Total excl. VAT",
  cCta: "Secure your spots",
  cNote: "You choose your week at the next step. Pay in 3 with Klarna.",
  fqEyebrow: "FAQ",
  fqTitle: "Still <em>unsure</em>?",
  erEyebrow: "What it earns you",
  erTitle: "How you earn your training back",
  erLead: "You don't have to make it a full time job. A few classes a week next to your practice is enough to feel the difference.",
  er1: "is what you earn on average per 45 minute class",
  er2f: "± €430",
  er2: "extra per month, teaching two classes a week",
  er3f: "35 classes",
  er3: "and your training has paid for itself. At two classes a week that takes just over four months",
  erNote: "Based on €50 per 45 minute class, the average rate at our studio, and a training price of €1,750 excl. VAT. What you earn yourself depends on the studio, your region and how many classes you teach.",
  rfLines: "You think you need months of training first.<br>Weekends spread over half a year, stacks of theory.<span class=\"turn\">But studios don't hire on hours. <strong>They hire on what you can show.</strong> That's why you do it here in five days, on the machine, with an exam where you teach.</span>",
  q5: "Isn't one week too short?",
  a5: "You practise for five days on a real group, instead of months on paper. Every day you teach, get feedback and teach again. And your exam tests exactly what studios ask for when they hire an instructor.",
  q6: "What if I can't make the week after all?",
  a6: "You can miss up to one day and possibly still take the exam. That does depend on your level. If it isn't there yet, we'll plan a catch up day with you during a later training, combined with an exam day. Because a group has a maximum of 15 spots, you can't always join the very next training straight away. If you're ill or injured, we'll reschedule the whole training with you. Refunds are not possible.",
  q1: "I've never taught before. Is this for me?",
  a1: "It's made for you. Most students have never taught a class. They've been on the Reformer a while, they love it, and they want to know whether they could stand in front of a group. That's where we start.",
  q2: "Can I book together with a friend?",
  a2: "Yes, and we recommend it. Choose Duo at the dates. You both get 10% off and you're in the same week together.",
  q3: "Can I pay in instalments?",
  a3: "Yes. You pay in 3 with Klarna. With a duo booking one of you pays for both spots at once, with 10% off.",
  q4: "What can I do after Level A?",
  a4: "You can teach beginner and intermediate classes on your own. Want to go further? Carry on to Level B and C.",
  fiTitle: "Your week <em>is on the list</em>",
  fiBody: "Five days. One certificate. And then you're the one in front of the group.",
  q7: "Where is the training held?",
  a7: "In our studio at De Stok 10b in Roosendaal. Free parking at the door and easy to reach by public transport.",
  q8: "Do I get course material?",
  a8: "Yes. You get course material that you keep, to prepare with and look back on after the week.",
  q9: "What does the practical exam look like?",
  a9: "On day five you teach a class yourself. Technique, class structure, cueing and safety are assessed. Then you receive your certificate.",
  q10: "How big is the group?",
  a10: "A maximum of 15 students, so you get personal feedback from your trainer every day.",
  footer: "Reformer Pilates Academy · Roosendaal",
  qzEyebrow: "Self-test",
  qzTitle: "Is it right for <em>you</em>? And what does it bring <em>you</em>?",
  qzLead: "Five questions. Then you'll know whether this suits you, and in how many weeks your training pays for itself.",
  qzCta: "Calculate my payback time",
  qzMeta: "5 questions · 60 seconds"
};
